import MarketSelect from '@/components/base/MarketSelect';

interface WalletToolbarProps {
  currency: string;
  onCurrency: (value: string) => void;
  markets: string[];
  onSetMarkets: (value: string[]) => void;
  query: string;
  onQuery: (value: string) => void;
  currencies: readonly string[];
}

export default function WalletToolbar({
  currency,
  onCurrency,
  markets,
  onSetMarkets,
  query,
  onQuery,
  currencies,
}: WalletToolbarProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4">
      <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
        <div className="relative">
          <span className="sr-only">Filter by currency</span>
          <select
            value={currency}
            onChange={(event) => onCurrency(event.target.value)}
            className="h-9 w-full cursor-pointer appearance-none rounded-md border border-background-300 bg-background-50 pl-3 pr-8 text-sm font-label text-foreground-700 focus:border-primary-400 focus:outline-none sm:w-40"
          >
            {currencies.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <i className="ri-arrow-down-s-line pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-foreground-500" />
        </div>

        <MarketSelect
          value={markets}
          onChange={onSetMarkets}
          placeholder="All markets"
          compact
          className="sm:w-44"
        />

        <div className="flex flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3">
          <i className="ri-search-line text-foreground-400" />
          <input
            type="text"
            value={query}
            onChange={(event) => onQuery(event.target.value)}
            placeholder="Search wallet or market..."
            className="h-9 w-full bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none sm:w-60"
          />
        </div>
      </div>
    </div>
  );
}